module.exports = __webpack_public_path__ + "img/blog6-1.d1906246.webp";